import { bgColor, focusVisible, hoverBgColor } from "../../Resources/CSS/styling";
import Breadcrumb from "../Breadcrumb";

export default function HeaderWithBreadcrumb({pages, title, actions}) {
    return (
        <div>
            <div>
                <Breadcrumb pages={pages} />
            </div>
            <div className="mt-2 md:flex md:items-center md:justify-between">
                <div className="min-w-0 flex-1">
                    <h2 className="text-2xl/7 font-bold text-gray-900 sm:truncate sm:text-3xl sm:tracking-tight">
                        {title}
                    </h2>
                </div>
                {actions && actions.length > 0 && <div className="mt-4 flex shrink-0 md:ml-4 md:mt-0">
                    {actions.map((action, index) => (
                        <button
                            type="button"
                            className={`ml-3 inline-flex items-center rounded-md ${bgColor} px-3 py-2 text-sm font-semibold text-white shadow-sm ${hoverBgColor} focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 ${focusVisible}`}
                    >
                        Edit
                    </button>))}
                </div>}
            </div>
        </div>
    )
}